import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../../utils/cn';
import { LogoSVG } from './LogoSVG';

const glowVariants = {
  initial: {
    opacity: 0,
    scale: 0.95,
  },
  hover: {
    opacity: [0.5, 0.7, 0.5],
    scale: 1.1,
    transition: {
      duration: 1.5,
      repeat: Infinity,
      ease: "easeInOut"
    }
  }
};

const shineVariants = {
  initial: {
    x: "-100%",
    opacity: 0
  },
  hover: {
    x: "100%",
    opacity: 0.4,
    transition: {
      duration: 1,
      ease: "easeInOut"
    }
  }
};

interface LogoProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

const Logo: React.FC<LogoProps> = ({ 
  className,
  width = 892,
  height = 530
}) => {
  return (
    <motion.div 
      className={cn(
        "inline-block relative",
        "overflow-hidden",
        className
      )}
      whileHover="hover"
      initial="initial"
      animate="initial"
    >
      {/* Glow effect */}
      <motion.div
        variants={glowVariants}
        className={cn(
          "absolute inset-0 rounded-full",
          "bg-primary-500/20 blur-2xl",
          "-z-10"
        )}
      />

      {/* Shine effect */}
      <motion.div
        variants={shineVariants}
        className={cn(
          "absolute inset-0",
          "bg-gradient-to-r from-transparent via-white/20 to-transparent",
          "skew-x-12"
        )}
      />

      {/* Logo */}
      <motion.div
        whileHover={{ scale: 1.05 }}
        transition={{
          type: "spring",
          stiffness: 400,
          damping: 10
        }}
      >
      <LogoSVG width={width} height={height} />
      </motion.div>
    </motion.div>
  );
};

export default Logo;